//Accepts Free Form Text
export const TEXT = 'Text';

// Accepts true or false
export const BOOLEAN = 'Boolean';

// Accepts decimal values
export const DECIMAL = 'Decimal';

// Accepts Complete non-decimal values
export const INTEGER = 'Integer';

// A decimal field with the percent logic. For example 0.03 -> 3%
export const PERCENT = 'Percent';
